import { PARTIES, PARTY_ORDER, type GlobalAggregate, type PartyId } from '../lib/types';

const nf = new Intl.NumberFormat('sv-SE');

interface Props {
  aggregate: GlobalAggregate;
}

export function PowerBalance({ aggregate }: Props) {
  const { districtMajority, totals } = aggregate;
  if (!districtMajority) return null;

  const leadCounts: Partial<Record<PartyId, number>> = {};
  for (const p of Object.values(districtMajority)) {
    leadCounts[p as PartyId] = (leadCounts[p as PartyId] ?? 0) + 1;
  }

  const maxLead = Math.max(...PARTY_ORDER.map(p => leadCounts[p] ?? 0), 1);

  const rows = PARTY_ORDER
    .map(p => ({ p, owned: totals.districtsByParty[p] ?? 0, leading: leadCounts[p] ?? 0 }))
    .filter(r => r.owned > 0 || r.leading > 0);

  if (!rows.length) return null;

  return (
    <div className="power-balance">
      <h3>Styrkeläge</h3>
      <p className="section-hint">Äger = över 50 % · Leder = flest anhängare (utan majoritet)</p>
      <div className="pb-list">
        {rows.map(({ p, owned, leading }) => (
          <div className="pb-row" key={p}>
            <div className="pb-label">
              <span className="party-dot" style={{ backgroundColor: PARTIES[p].color }} />
              <span className="pb-party-id">{p}</span>
            </div>
            <div className="pb-bars">
              <div className="pb-track">
                <div
                  className="pb-fill pb-fill--lead"
                  style={{ width: `${(leading / maxLead) * 100}%`, backgroundColor: PARTIES[p].color }}
                />
              </div>
              <div className="pb-track">
                <div
                  className="pb-fill"
                  style={{ width: `${(owned / maxLead) * 100}%`, backgroundColor: PARTIES[p].color }}
                />
              </div>
            </div>
            <div className="pb-values">
              <span>{nf.format(owned)}</span>
              <span className="pb-lead-count">{nf.format(leading)} leder</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
